import { connect } from 'react-redux';

import { Button, Pagination, Snackbar } from 'components';
import Expander from 'components/Expander';
import { IntegrationEnum } from 'gql/graphql';
import { QuestionIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import TextNavigation from './TextNavigation';
import { getParamsCreateTr, useSelectionContentFlow } from './_actions';
import { getFiles, getFilteredContent, getIntegration, getSelectedFile } from './_selectors';

const PAGE_SIZE = 20;

interface ITextFileFlow {
  files: any[];
  selectedFile: { keys: string[] };
  filteredContent: string[];
  integration?: string;
  useSelectionContentFlow: () => void;
}

const TextFileFlow: FC<ITextFileFlow> = ({
  files,
  filteredContent,
  integration,
  selectedFile: { keys },
  useSelectionContentFlow: selectionContentFlow
}) => {
  const t = useTranslations();

  const [page, setPage] = useState(1);

  const keysResult = [...new Set(keys)].filter((key) =>
    [IntegrationEnum.Hubspot, IntegrationEnum.Hubdb].includes(integration as IntegrationEnum)
      ? filteredContent.includes(key)
      : true
  );

  const totalPages = Math.ceil(keysResult.length / PAGE_SIZE),
    currentIndex = (page - 1) * PAGE_SIZE;

  const handlerChangePagination = (page: number) => setPage(page);

  return (
    <div>
      <div className="ordering_form__explanation">
        <Snackbar
          className="mb-4 border border-solid border-tertiary-400"
          icon={<QuestionIcon class="!text-primary-blue-100" />}
          description={
            <div className="">
              {t('ordering_form.text_file_explanation1')}{' '}
              {t('ordering_form.text_file_explanation2').replace('&gt;', '>').replace('&lt;', '<')}
            </div>
          }
        />
      </div>

      {files?.length > 1 && (
        <div className="flex flex-wrap gap-2">
          {files.map((file, index) => (
            <TextNavigation key={file.fileName + index} fileName={file.fileName} index={index} />
          ))}
        </div>
      )}
      <div className="ordering_form__text_file_content mt-3">
        {keysResult.slice(currentIndex, currentIndex + PAGE_SIZE).map((key, index) => (
          <Expander
            key={index}
            className="my-0"
            classNameContainer="!max-w-full"
            classNameChildren="!w-full !bg-transparent"
            classNamePanel="!pt-0"
            classNameTitle="py-1 !font-medium !text-2xl"
          >
            {key}
          </Expander>
        ))}
      </div>
      <Pagination
        totalPages={totalPages}
        page={page}
        changePage={handlerChangePagination}
        className="my-6 flex justify-center"
      />
      <div className="my-6 flex justify-center">
        <Button
          label={t('ordering_form.back_to_selection')}
          onClick={selectionContentFlow}
          size="medium"
          variant="text"
        />
      </div>
    </div>
  );
};

export default connect(
  (state) => {
    return {
      files: getFiles(state),
      selectedFile: getSelectedFile(state),
      filteredContent: getFilteredContent(state),
      integration: getIntegration(state)
    };
  },
  { useSelectionContentFlow, getParamsCreateTr }
)(TextFileFlow);
